import { useEffect, useState } from "react";
import "./ProviderModal.css";
import { getProviderSuccessRate } from "../../../config/LiveApi";
import { Close } from "@mui/icons-material";

const ProviderModal = ({ setShowModal }) => {
  const [providerData, setProviderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [minutes, setMinutes] = useState(60);
  const [debouncedMinutes, setDebouncedMinutes] = useState(60);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMinutes(minutes);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [minutes]);

  const fetchData = async (min) => {
    try {
      setLoading(true);
      const response = await getProviderSuccessRate(min);
      if (response?.status) {
        setProviderData(response.data || []);
      }
    } catch (err) {
      console.error("Error fetching provider success rate:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(debouncedMinutes);
  }, [debouncedMinutes]);

  return (
    <div className="overlay-provider-success">
      <div className="modal-provider-success">
        <div className="modal-header-provider-success">
          <h3 className="title-provider-success">📊 Provider Success Rate</h3>
          <Close
            onClick={() => setShowModal(false)}
            className="close-btn-provider-success"
          />
        </div>
        {/* Minutes Input */}
        <div className="filter-provider-success">
          <label htmlFor="minutesInput">Enter Minutes: </label>
          <input
            id="minutesInput"
            type="number"
            value={minutes}
            min="1"
            onChange={(e) => setMinutes(Number(e.target.value))}
            className="input-provider-success"
          />
        </div>

        <div className="table-wrapper-provider-success">
          <table className="table-provider-success">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Provider (PG)</th>
                <th>Org Name</th>
                <th>Total Txn</th>
                <th>Total Payin</th>
                <th>Total Success Amount</th>
                <th>Success Count</th>
                <th>Processing Count</th>
                <th>Failed Count</th>
                <th>Success Rate (%)</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="no-data-provider-success">
                    Loading...
                  </td>
                </tr>
              ) : providerData && providerData.length > 0 ? (
                providerData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.pg || "N/A"}</td>
                    <td>{item.orgName || "N/A"}</td>
                    <td>{item.totalTransactions || 0}</td>
                    <td>{Number(item.totalPayin || 0).toFixed(2)}</td>
                    <td>{Number(item.totalSuccessPayin || 0).toFixed(2)}</td>
                    <td className="success-provider-success">
                      {item.successCount || 0}
                    </td>
                    <td className="processing-provider-success">
                      {item.processingCount || 0}
                    </td>
                    <td className="failed-provider-success">
                      {item.failedCount || 0}
                    </td>
                    <td>{item.successRatePercent || 0}%</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="no-data-provider-success">
                    No provider data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProviderModal;
